import type React from "react";
import { ReactComponent as Svg } from "./assets/lost.svg";
import * as styles from "./Icon.module.scss";

type LostProps = React.SVGProps<SVGSVGElement>;

export const Lost = ({ className, ...props }: LostProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
